import { useState } from 'react';
export const useValidator = ({ inputSchema, selectSchema }) => {
    const [formErrors, setErrors] = useState({});
    const validateInputField = ({ fieldName, value, context, customInputSchema, }) => {
        if (customInputSchema || inputSchema) {
            const validators = customInputSchema
                ? customInputSchema[fieldName]
                : inputSchema
                    ? inputSchema[fieldName]
                    : [];
            if (!validators) {
                return false;
            }
            const fieldErrors = validators
                .map((fn) => fn(value, context))
                .filter((error) => error !== null);
            setErrors((prev) => ({
                ...prev,
                [fieldName]: fieldErrors,
            }));
            return fieldErrors.length > 0;
        }
        return false;
    };
    const validateSelect = (fieldName, isSelected, customSelectSchema) => {
        if (customSelectSchema || selectSchema) {
            const validators = customSelectSchema
                ? customSelectSchema[fieldName]
                : selectSchema
                    ? selectSchema[fieldName]
                    : [];
            if (!validators) {
                return false;
            }
            const fieldErrors = validators.map((fn) => fn(isSelected)).filter((error) => error !== null);
            setErrors((prev) => ({
                ...prev,
                [fieldName]: fieldErrors,
            }));
            return fieldErrors.length > 0;
        }
        return false;
    };
    const validateAll = ({ inputValues, selectValues, context, customSelectSchema, customInputSchema, newValidation = true, }) => {
        const newErrors = {};
        if ((customInputSchema || inputSchema) && inputValues) {
            const currentInputSchema = customInputSchema ? customInputSchema : inputSchema;
            Object.entries(currentInputSchema).forEach(([field, validators]) => {
                if (!validators) {
                    return {};
                }
                const value = inputValues[field] || '';
                const fieldErrors = validators
                    .map((fn) => fn(value, context))
                    .filter((err) => err !== null);
                if (fieldErrors.length > 0) {
                    newErrors[field] = fieldErrors;
                }
            });
        }
        if ((customSelectSchema || selectSchema) && selectValues) {
            const currentSelectSchema = customSelectSchema ? customSelectSchema : selectSchema;
            Object.entries(currentSelectSchema).forEach(([field, validators]) => {
                if (!validators) {
                    return {};
                }
                const isSelected = selectValues[field] || false;
                const fieldErrors = validators
                    .map((fn) => fn(isSelected))
                    .filter((err) => err !== null);
                if (fieldErrors.length > 0) {
                    newErrors[field] = fieldErrors;
                }
            });
        }
        if (newValidation) {
            setErrors(newErrors);
        }
        else {
            setErrors((prev) => ({ ...prev, ...newErrors }));
        }
        return newErrors;
    };
    const clearErrors = (fieldName) => {
        if (fieldName) {
            setErrors((prev) => {
                const { [fieldName]: _, ...rest } = prev;
                return rest;
            });
        }
        else {
            setErrors({});
        }
    };
    const hasErrors = Object.values(formErrors).some((fieldErrors) => fieldErrors.length > 0);
    return {
        formErrors,
        setFormErrors: setErrors,
        validateInputField,
        validateSelect,
        validateAll,
        hasErrors,
        clearErrors,
    };
};
